export const ToastTypes = {
    Success: 'success',
    Error: 'error',
    None: '',
};
